import Type from "@/model/types/Type";



const type = {
    PENDING : 1,
    PROCESSING : 2,
    PROCESSED : 3,
    ERROR : 90,
}

const list = [
    {
        value: type.PENDING,
        text: "Pendente",
    },
    {
        value: type.PROCESSING,
        text: "Em processamento",
    },
    {
        value: type.PROCESSED,
        text: "Processado",
    },
    {
        value: type.ERROR,
        text: "Erro",
    },

]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

const hasDone = function(t) {
    return t === type.DONE || t === type.REPROVED
}

export default {
    type,
    list,
    contains,
    hasDone
}


